import {
  AfterContentInit, AfterViewInit, Component, OnDestroy, OnInit, ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ITreatyState } from '../../store/reducers/treaty.reducer';
import {select, Store} from '@ngrx/store';
import {BreadcrumbModel} from "@shared/models/breadcrumb.model";
import {Configuration} from "@shared/models/configuration";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {QueryProvider} from "@shared/queries/query-provider";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {FileInfo, OtherDocument} from "../../models/treaty.models";
import {TreatyApiService} from "../../services/treaty.service";
import {VirtualGridComponent} from "@shared/components/virtual-grid/virtual-grid.component";
import { process, State } from '@progress/kendo-data-query';
import {FormBuilder, FormGroup} from '@angular/forms';
import {GetOtherDocumentInfoAction} from "../../store/actions/treaty.actions";
import {getOtherDocument} from "../../store/selectors/treaty.selector";


@Component({
    standalone: false,
    selector: 'particle-treaty-list',
  templateUrl: './treaty-list.component.html',
  styleUrls: ['./treaty-list.component.scss']
})

export class TreatyListComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentInit {
  @ViewChild(VirtualGridComponent, {static: true})  gridRef: VirtualGridComponent;
  currentMenu: string;
  ngUnsubscribe$ = new Subject<void>();
  sourceKey: string;
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbs$: any;
  breadcrumbKey: string;
  documentType: string;
  otherVersionsContentViewEnable: boolean;
  otherVersions: FileInfo[];
  inputForm: any;
  otherDocuments: OtherDocument[];
  private config: any;
  constructor(private treatyStore: Store<ITreatyState>,
              protected activatedRoute: ActivatedRoute,
              private queryState: Store<IQueryState>,
              private router: Router,
              private treatyService: TreatyApiService,

              private formBuilder: FormBuilder) {
    this.breadcrumbKey = 'BreadcrumbByTreatyId';
    this.sourceKey = 'TreatyRepository';
    this.invalidateSubject = new InvalidateSubject();
    this.inputForm = this.formBuilder.group({
      value  : ['']
    });
  }

  ngOnInit(){

    this.inputForm.valueChanges.subscribe(data=> {
      const state: State = {
        // Initial filter descriptor
        filter: {
          logic: 'and',
          filters: [{ field: 'cells.Name.displayText', operator: 'startswith', value: data.value }]
        }
      };

      this.gridRef.gridView = this.fun(this.gridRef.view, state, data.value);
      console.log("Show the view:::", this.gridRef.gridView);
    });
    this.otherVersionsContentViewEnable = false;
    this.activatedRoute.params.subscribe((params: any) => {
      const group= params.group;
      const id1= params.id1;
      const id2= params.id2;
      const documentId= params.documentId;
      let id  = this.getGroupId(group);
      this.documentType = id;
      if(id1){
        id += '-'+ id1;
      }
      if(id2){
        id += '-'+ id2;
      }
      if(documentId){
        id += '-'+ documentId;
      }

      if(id1 && id2) {
        this.treatyService.getOtherVersions(id1, id2).subscribe(data => this.otherVersions = data);
      }

      this.breadcrumbs$ = this.queryState.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, this.breadcrumbKey));
      this.breadcrumbs$.subscribe(state => {
        if (state) {
          this.breadcrumbs = state.breadcrumb;
        }
      });
      QueryProvider.invokeQuery(this.queryState, this.breadcrumbKey, {'[ID]': id});
      const config = Configuration.getSmartGridConfig(this.sourceKey);
      config.Parameters['PARENT_ID'] = id;
      //this.invalidateSubject.invalidate(id);
    });
  }


  private fun(view: any, state: State, search: string) {
    console.log("received:::", view);
    const data = view.filter(data => data.cells.RequestedJurisdiction.displayText.toLowerCase().startsWith(search));
    return {
      data: data,
      total: data.length
    }

  }
  ngAfterContentInit() {
    if(this.gridRef)
    {
      console.log("VirtualGrid:::", this.gridRef);
    }
  }
  ngAfterViewInit() {
    this.treatyStore.dispatch(new GetOtherDocumentInfoAction());

  }

  private getGroupId(group: string) {
    switch (group){
      case 'documents':
        return 'treaty-documents';
      default:
        return group;
    }
  }
  onGridCellValueChange($event) {
    console.log('Testing ->', event);
    const id = $event.cells['Name'].value;
    const type = $event.cells['Type'].value;
    const countryCode = $event.cells['CountryCode'].value;
    const documentId = $event.cells['DocumentId'].value;
    if(type == 'Document') {
      this.router.navigate([documentId], {relativeTo: this.activatedRoute});
    }
    else if(type == 'StatusDocument'){
      this.router.navigate(['treaty-status'], {relativeTo: this.activatedRoute});
    }
    else if(countryCode) {
      this.router.navigate([countryCode.toLowerCase()], {relativeTo: this.activatedRoute});
    } else {
      this.router.navigate([id], {relativeTo: this.activatedRoute});
    }
  }

  otherVersionDisplay() {
    this.otherVersionsContentViewEnable = !this.otherVersionsContentViewEnable;
  }

  showPdf(file: FileInfo) {
    console.log("File Url:::", file);
    let title = file.title;
    if(file.language) {
      title += ' -' + file.language;
    }
    this.router.navigate([`otherVersion/${file.id}`], {
      relativeTo: this.activatedRoute,
      queryParams: {title: title}
    });
  }

  treatyStatus() {
    this.router.navigate([`treaty-status`], {
      relativeTo: this.activatedRoute,
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
